import { Component, ElementRef, OnInit, SimpleChanges, ViewChild, Inject, OnDestroy } from '@angular/core';
import { Globals } from '../../globals';
import * as moment from 'moment';
import { PrescriptionListingModel, CreatePrescriptionUrlModel, CreateQueueUrlModel } from './models';
import { DoctorsComponent } from '../configuration/doctors/doctors.component';
import { eRxService } from './erx.service';
import { IconRegistryService } from '../../utilities/icon-registry.service';
import { CaseFormsService } from '../case-forms/case-forms.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import { LandingPageService } from '../../services/landing-page.service';
import { CaseProcedureDataModel } from '../../models/caseProcedures/case-procedure-data.model';
import { PatientService } from '../patient/patient.service';
import { ContactDataModel } from '../../models/person/contact-data.model';
import { TdoTableSelectionEvent } from '../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { TdoTableV2Component } from '../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-erx',
  templateUrl: './erx.component.html',
  styleUrls: ['./erx.component.scss']
})
// tslint:disable-next-line:class-name
export class eRxComponent implements OnInit, OnDestroy {
  private iframePlaceholder: ElementRef;

  @ViewChild('prescriptionTable') prescriptionTable: TdoTableV2Component;
  private chartOpen: boolean;
  @ViewChild('iframe') set iframe(content: ElementRef) {
    if (content) {
      this.iframePlaceholder = content;
    }
  }
  @ViewChild(DoctorsComponent) doctorsConfig: DoctorsComponent;

  moment = moment;

  patientCaseList4Fix: any[];
  caseWorkItemList4Fix: CaseProcedureDataModel[];
  caseFormControl = new UntypedFormControl('', [Validators.required]);
  caseWorkItemFormControl = new UntypedFormControl('', [Validators.required]);

  prescriptions: PrescriptionListingModel[] = [];
  popupVisible: boolean = false;

  showIFrame: boolean = false;
  iFrameLoaded: boolean = false;
  iframeLoadError: boolean = false;
  iframeWidth: string = '80%';
  iframeHeight: string = '80%';

  userContact: ContactDataModel = new ContactDataModel();
  errorMessage: string = '';

  selectedPrescriptionJson: any = {};

  showDoctor: boolean = false;
  currentDoctorID: string = '';
  isLoading: boolean = true;

  showFixPrescription: boolean = false;
  selectedPrescriptionToFix: PrescriptionListingModel = null;
  eRxTemp: string = '';
  isValidPatient: boolean = true;
  searchPredicate: (data: any, filter: string) => boolean;

  constructor(
    public globals: Globals,

    private readonly _eRxService: eRxService,
    private readonly _caseService: CaseFormsService,
    iconRegistryService: IconRegistryService,
    private readonly _landingPageService: LandingPageService,
    private readonly patientService: PatientService,
    private readonly localStorageService: LocalStorageService,
    private readonly dialogService: DialogService,
    private readonly dialog: MatDialog
  ) {
    iconRegistryService.registerIcon('medicine', './assets/icons/icons8-pill-bottle.svg');
    iconRegistryService.registerIcon('outline-right', './assets/icons/icons8-next-page.svg');
    iconRegistryService.registerIcon('info', './assets/icons/forward.svg');
    iconRegistryService.registerIcon('patientValidationApproved', './assets/icons/eRXPersonGreen.svg');
    iconRegistryService.registerIcon('patientValidationWithIssue', './assets/icons/erxPersonRed.svg');

    this.searchPredicate = (dataSearch: PrescriptionListingModel, filter: string) => {
      return dataSearch.doctorName.toLowerCase().includes(filter) ||
        dataSearch.medication.toLowerCase().includes(filter);
    };
  }
  ngOnDestroy(): void {
    this.updatePrescriptions();
  }

  updatePrescriptions() {
    this.isLoading = true;
    const model = new CreatePrescriptionUrlModel({
      patientID: this.globals.currentPatientId,
      patientCaseID: this.globals.currentPatientCaseId,
      doctorID: this.currentDoctorID
    });
    this._eRxService.refreshPatientPrescription(model).subscribe((res) => {
      this.getPatientRx();
    },
      error => {
        console.log("updatePrescriptions ERROR:", error);
        this.isLoading = false;
      });
  }

  async ngOnInit() {
    //validate the data for the patient
    this.isLoading = true;
    if (!this.localStorageService.practicingDoctorId && !this.localStorageService.loggedInDoctorId) {
      this.dialogService.openConfirmDialog('You are not signed in as a doctor and no doctor was selected from the case view.');
    } else
      if (this.localStorageService.practicingDoctorId) {
        this.currentDoctorID = this.localStorageService.practicingDoctorId;
      } else {
        this.currentDoctorID = this.localStorageService.loggedInDoctorId;
      }

    this.validatePatient();
    if (this.globals.currentPatientCaseId) {
      this.getPatientRx();
    }
    else
      this.isLoading = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.globals.currentValue) {
      this._caseService.getPatientCases(this.globals.currentPatientCaseId).subscribe(
        data => {
          this.patientService.getPatient(this.globals.currentPatientId).subscribe(async (res) => {
            if (this.chartOpen === true) {
              this.onOpenErx4Patient();
            }
          });

        },
        error => { console.log("ngOnchanges ERROR:", error); }
      );
    }
  }

  onFixPrescription(event: TdoTableSelectionEvent): void {
    this.selectedPrescriptionToFix = this.prescriptions.find(p => p === event.model);
    this._landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe(
      data => {
        this.patientCaseList4Fix = data;
      },
      error => { console.log("onFixPrescription ERROR: ", error); }
    );
    this.showFixPrescription = true;
  }

  onCaseSelection4Fix(): void {
    if (!this.caseFormControl.value) { return; }
    this._caseService.getPatientCases(this.caseFormControl.value).subscribe(
      (data) => { this.caseWorkItemList4Fix = data; },
      error => { console.log(error); }
    );
  }

  onUpdatePrescription(): void {
    this.isLoading = true;
    this._eRxService.updatePrescription(this.selectedPrescriptionToFix.prescriptionID,
      this.caseFormControl.value, this.caseWorkItemFormControl.value)
      .subscribe(
        (data: any) => {
          console.log("onUpdatePrescription: ", data);
          this.selectedPrescriptionToFix =  new PrescriptionListingModel(
            data.RxId,
            data.CaseReference,
            moment(data.RxDate),
            data.DispenseQuantity,
            data.DispenseUnit,
            data.Dosage,
            data.DosageForm,
            data.Medication,
            data.Directions,
            data.Refill,
            data.DoctorID,
            data.DoctorName,
            data.PharmacyID,
            data.PharmacyName,
            data.PharmacyPhoneNumber,
            data.JsonString,
            '',
            data.eRxPharmacyID,
            data.eRxPharmacyName
          );
          const replaceIndex = this.prescriptions.findIndex(p => p.prescriptionID === this.selectedPrescriptionToFix.prescriptionID);
          console.log("replaceIndex: ", replaceIndex);
          
          this.prescriptions[replaceIndex] = this.selectedPrescriptionToFix;
          console.log("prescriptionTable: ", this.prescriptionTable);
          if (this.prescriptionTable){
            console.log("replaceIndex: ", this.prescriptions[replaceIndex] );
            this.prescriptionTable.updateData(this.prescriptions);
          }
          this.isLoading = false;
        },
        (error) => {
          console.log("onUpdatePrescription: ", error);
          this.isLoading = false;
        });
  }

  closePopUp(): void {
    if (this.showIFrame) {
      this.updatePrescriptions();
    }
    this.resetPopups();
  }

  getPatientRx() {
    this.isLoading = true;
    this.prescriptions = [];
    this._eRxService.getPrescriptions(this.globals.currentPatientId).subscribe(
      // tslint:disable-next-line:no-shadowed-variable
      (response: any[]) => {
        this.prescriptions = response.map(o => new PrescriptionListingModel(
          o.RxId,
          o.CaseReference,
          moment(o.RxDate),
          o.DispenseQuantity,
          o.DispenseUnit,
          o.Dosage,
          o.DosageForm,
          o.Medication,
          o.Directions,
          o.Refill,
          o.DoctorID,
          o.DoctorName,
          o.PharmacyID,
          o.PharmacyName,
          o.PharmacyPhoneNumber,
          o.JsonString,
          '',
          o.eRxPharmacyID,
          o.eRxPharmacyName
        ));

        if (this.prescriptionTable)
          this.prescriptionTable.updateData(this.prescriptions);
        this.isLoading = false;
      },
      error => {
        console.log("getPatientRx: ", error);
        this.isLoading = false;
      }
    );
  }

  onOpenErxReport(): void {
    this.popupVisible = true;
    this.showIFrame = true;
    this.errorMessage = '';
    this.isLoading = true;

    const model = new CreateQueueUrlModel({
      doctorID: this.currentDoctorID
    });

    this._eRxService.getReportUrl(model).subscribe(
      result => {
        const nativeEl = this.iframePlaceholder.nativeElement;

        // add event listener to see when iframe content is done loading
        if ((nativeEl.contentDocument || nativeEl.contentWindow.document).readyState === 'complete') {
          nativeEl.onload = this.onIframeLoad.bind(this);
        }
        else
          if (nativeEl.addEventListener) {
            nativeEl.addEventListener('load', this.onIframeLoad.bind(this), true);
          }
          else if (nativeEl.attachEvent) {
            nativeEl.attachEvent('onload', this.onIframeLoad.bind(this));
          }
        nativeEl.src = result.url;
        this.isLoading = false;

      },
      error => {
        console.log("onOpenErxReport: ", error);
        this.showIFrame = false;
        this.iframeLoadError = true;
        this.errorMessage = error.error.ExceptionMessage ?? "Error contacting eRX Service.";
        this.isLoading = false;
        this.openErrorDialog(this.errorMessage);
      });
  }


  validatePatient(): void {
    const model = new CreatePrescriptionUrlModel({
      patientID: this.globals.currentPatientId,
      patientCaseID: this.globals.currentPatientCaseId,
      doctorID: this.currentDoctorID
    });

    this._eRxService.validatePatient(model).subscribe(
      result => {
        if (result.strErrorMessages.length > 0) {
          this.isValidPatient = false;
          this.openErrorDialog(result.strErrorMessages);
        }
      },
      error => {
        console.log("validatePatient ERROR: ", error);
        this.showIFrame = false;
        this.iframeLoadError = true;
        this.chartOpen = false;
        this.errorMessage = error.error.Message ?? "Error contacting eRX Service.";
      });

  }

  openErrorDialog(errorMsgs: string): void {
    console.log("openErrorDialog: ", errorMsgs);
    const dialogRef = this.dialog.open(PatientDataMissingDialog, {
      width: '600px',
      height: '600px',
      data: errorMsgs
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onOpenErx4Patient(): void {
    this.isLoading = true;
    this.popupVisible = true;
    this.showIFrame = true;
    this.errorMessage = '';

    const model = new CreatePrescriptionUrlModel({
      patientID: this.globals.currentPatientId,
      patientCaseID: this.globals.currentPatientCaseId,
      doctorID: this.currentDoctorID
    });

    this._eRxService.getPrescriptionUrl(model).subscribe(
      result => {
        if (result.eRxPatientID != 0) {
          const nativeEl = this.iframePlaceholder.nativeElement;

          // add event listener to see when iframe content is done loading
          if ((nativeEl.contentDocument || nativeEl.contentWindow.document).readyState === 'complete') {
            nativeEl.onload = this.onIframeLoad.bind(this);
          }
          else
            if (nativeEl.addEventListener) {
              nativeEl.addEventListener('load', this.onIframeLoad.bind(this), true);
            }
            else if (nativeEl.attachEvent) {
              nativeEl.attachEvent('onload', this.onIframeLoad.bind(this));
            }
          this.chartOpen = true;
          nativeEl.src = result.url;
          this.isLoading = false;
        }

        else {
          this.showIFrame = false;
          this.iframeLoadError = true;
          this.chartOpen = false;
          this.errorMessage = result.ret;
          this.isLoading = false;
        }
      },
      error => {
        console.log("onOpenErx4Patient: ", error);
        this.isLoading = false;
        this.showIFrame = false;
        this.iframeLoadError = true;
        this.chartOpen = false;
        this.errorMessage = error.error.Message ?? "Error contacting eRX Service.";
        this.openErrorDialog(this.errorMessage);
      });
  }

  onIframeLoad() {
    this.errorMessage = '';
    console.log('iframe loaded');
    this.iFrameLoaded = true;
  }


  private resetPopups(): void {
    this.popupVisible = false;
    this.showDoctor = false;
    this.chartOpen = false;
    this.showIFrame = false;
    this.iFrameLoaded = false;
    this.iframeLoadError = false;
    this.showFixPrescription = false;
    this.selectedPrescriptionToFix = null;
    this.iframeWidth = '80%';
    this.iframeHeight = '80%';
    this.caseWorkItemList4Fix = null;
    this.caseFormControl.setValue('');
    this.caseWorkItemFormControl.setValue('');
    this.errorMessage = '';
  }
}
@Component({
  selector: 'erxPatientDataMissing',
  templateUrl: 'erxPatientDataMissing.html',
})
export class PatientDataMissingDialog {

  constructor(
    public dialogRef: MatDialogRef<PatientDataMissingDialog>,
    @Inject(MAT_DIALOG_DATA) public data: string) { }
  firstName: string = "";
  lastName: string = "";
  middleName: string = "";
  address: string = "";
  city: string = "";
  zip: string = "";
  state: string = "";
  firstNameErr: string = "";
  lastNameErr: string = "";
  addressErr: string = "";
  cityErr: string = "";
  zipErr: string = "";
  stateErr: string = "";
  birth: string = "";
  birthErr: string = "";
  phone: string = "";
  phoneErr: string = "";
  additionalErr: string = "✔ No Additional Errors";
  err: boolean = false;
  AddErr: boolean = false;
  ngOnInit() {
    if (this.data.toUpperCase().includes('FIRST NAME')) {

      this.firstNameErr = "❌ First name is required and should be 35 characters or less.";
      this.err = true;
    } else {
      this.firstName = "✔ First Name.";
    }
    if (this.data.toUpperCase().includes('LAST NAME')) {

      this.lastNameErr = "❌ Last name is required and should be 35 characters or less.";
      this.err = true;
    } else {
      this.lastName = "✔ Last Name.";
    }
    if (this.data.toUpperCase().includes('ADDRESS')) {

      this.addressErr = "❌ Address is required and each line should be 35 characters or less.";
      this.err = true;
    } else {
      this.address = "✔ Address.";
    }
    if (this.data.toUpperCase().includes('CITY')) {
      this.err = true;
      this.cityErr = "❌ City is required and should be 35 characters or less.";
    } else {
      this.city = "✔ City Name.";
    }
    if (this.data.toUpperCase().includes('ZIP')) {
      this.err = true;
      this.zipErr = "❌ Zip code is required and should be 35 characters or less.";
    } else {
      this.zip = "✔ Zip code.";
    }
    if (this.data.toUpperCase().includes('STATE')) {
      this.err = true;
      this.stateErr = "❌ State is required and should be 35 characters or less.";
    } else {
      this.state = "✔ State Name.";
    }
    if (this.data.toUpperCase().includes('BIRTH')) {
      this.err = true;
      this.birthErr = "❌ Birth date is required.";
    } else {
      this.birth = "✔ Birth date.";
    }
    if (this.data.toUpperCase().includes('PHONE')) {
      this.err = true;
      this.phoneErr = "❌ Phone number: home/cell/work is required..";
    } else {
      this.phone = "✔ Phone number: home/cell/work.";
    }
    if (this.data.toUpperCase().includes('SYSTEM ERROR')) {
      this.err = true;
      this.additionalErr = "❌ " + this.data.split("Per Daw")[0];
    }
    if (this.err == false && this.data.length > 0) {
      this.additionalErr = "❌ " + this.data;

    }

  }
  onCloseClick(): void {
    this.dialogRef.close();
  }

}